import { render, staticRenderFns } from "./CakeshopsNewStepOne.vue?vue&type=template&id=4eff3cb6&scoped=true&"
import script from "./CakeshopsNewStepOne.vue?vue&type=script&lang=js&"
export * from "./CakeshopsNewStepOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff3cb6",
  null
  
)

export default component.exports